import axios from 'axios';

export default class KeycloakAPI {
    static getUsers() {
        return new Promise((resolve, reject) => {
            axios.get(`/backoffice/keycloak/users`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => reject(err))
        });
    }

    static resendVerification(email) {
        return new Promise((resolve, reject) => {
            axios.post(`/backoffice/keycloak/resend-verification`, { email })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => reject(err))
        });
    }

    static resetPassword(email) {
        return new Promise((resolve, reject) => {
            axios.post(`/backoffice/keycloak/reset-password`, { email })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => reject(err))
        });
    }
} 